import { render, staticRenderFns } from "./direito.vue?vue&type=template&id=44ba46eb&scoped=true&"
import script from "./direito.vue?vue&type=script&lang=js&"
export * from "./direito.vue?vue&type=script&lang=js&"
import style0 from "./direito.vue?vue&type=style&index=0&id=44ba46eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba46eb",
  null
  
)

export default component.exports